export default __webpack_public_path__ + "static/media/loadingEnabill.625f6f69.svg";